import { memo } from 'react';
import { ratingCorMap, ratingIconMap } from '@restworld/utils-common';
import { RatingChartProps } from './rating.constants';
import { ratingIconProps } from '@restworld/utils-common';

export function RatingChart({ rating, icon }: RatingChartProps) {
  return (
    <svg width="74" height="72" viewBox="0 0 74 72" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.5977 58.4023C11.9113 60.0887 9.15324 60.1027 7.68074 58.2266C4.20172 53.7939 1.79887 48.5892 0.69173 43.0233C-0.697338 36.0399 0.0155821 28.8015 2.74034 22.2234C5.46509 15.6453 10.0793 10.0228 15.9995 6.06709C21.9196 2.11136 28.8799 -8.49067e-08 36 0C43.1201 8.49067e-08 50.0804 2.11136 56.0005 6.06709C61.9207 10.0228 66.5349 15.6453 69.2597 22.2234C71.9844 28.8015 72.6973 36.0399 71.3083 43.0233C70.2011 48.5892 67.7983 53.7939 64.3193 58.2266C62.8468 60.1027 60.0887 60.0887 58.4023 58.4023C56.7158 56.7158 56.7488 53.9978 58.1492 52.0673C60.4579 48.8848 62.0638 45.2276 62.8374 41.3383C63.8933 36.0304 63.3514 30.5285 61.2803 25.5285C59.2093 20.5286 55.702 16.255 51.2022 13.2483C46.7023 10.2416 41.4119 8.63678 36 8.63678C30.5881 8.63678 25.2977 10.2416 20.7978 13.2483C16.2979 16.255 12.7907 20.5286 10.7197 25.5285C8.64862 30.5285 8.10674 36.0304 9.16255 41.3383C9.93618 45.2276 11.5421 48.8848 13.8508 52.0673C15.2512 53.9978 15.2842 56.7158 13.5977 58.4023Z"
        fill="url(#paint0_linear_219_8807)"
      />
      <circle
        cx={ratingCorMap[rating].x}
        cy={ratingCorMap[rating].y}
        r="5"
        fill="#693EB5"
        stroke="white"
        strokeWidth="2"
      />
      {ratingIconMap[icon as ratingIconProps]}
      <defs>
        <linearGradient
          id="paint0_linear_219_8807"
          x1="6.32967"
          y1="19.3846"
          x2="77.1429"
          y2="-2.37363"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E2D8F3" />
          <stop offset="1" stopColor="#BCCF00" />
        </linearGradient>
        <clipPath id="clip0_219_8807">
          <rect width="32" height="32" fill="white" transform="translate(21 20)" />
        </clipPath>
      </defs>
    </svg>
  );
}
export default memo(RatingChart);
